import Text from '@deprecated-ui/common/Text';
import { TargetPriceParams } from '../types';
import { FooterContainer, TargetPriceContainer } from './styled';
import TargetPriceInputNumber from './TargetPriceInputNumber';
import TargetPriceSearch from './TargetPriceSearch';
import TargetPriceSelect from './TargetPriceSelect';

interface TargetPriceProps {
  targetPrice: TargetPriceParams;
  onChange: (val: any) => any;
  onClose: () => any;
}

function TargetPrice({ targetPrice, onChange, onClose }: TargetPriceProps) {
  const handleChange = (val) => {
    onChange(val);
  };

  const handleCloseTargetPrice = () => {
    onClose();
  };

  return (
    <TargetPriceContainer>
      <TargetPriceSearch
        symbol={targetPrice.target_symbol}
        onChangeSymbol={handleChange}
      />
      <TargetPriceInputNumber
        price={targetPrice.target_price}
        onChangePrice={handleChange}
      />
      <TargetPriceSelect
        duration={targetPrice.target_duration}
        onChangeDuration={handleChange}
      />
      <FooterContainer>
        <Text as="button" onClick={handleCloseTargetPrice}>
          Remove
        </Text>
      </FooterContainer>
    </TargetPriceContainer>
  );
}

export default TargetPrice;
